import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'

import { useHook } from '../../../lenteHooks'
import { OverviewTitle } from '../../overview/OverviewTitle'

export const CommitmentSectionTitle = () => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()
  const { ownerId, tenantId } = useHook('routing.general.useEntityParams')()
  const { data: commitmentVersion } = useHook(
    'fetchers.life.useFetchCommitmentVersionLatest',
  )({ ownerId, tenantId })

  return (
    <OverviewTitle
      tip={translate('commitmentStatus.status')}
      data-testid="commitment-status-section-title"
    >
      {translateEnum(
        'life.enum.CommitmentStatus',
        commitmentVersion?.commitmentStatus,
      )}
    </OverviewTitle>
  )
}
